var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpicM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 4.5V3H14.985V4.5H7.5ZM19.5 4.5H21V3.00746H19.5V4.5ZM8.25751 13.4773H6.75751V11.9848H8.25751V13.4773ZM17.9925 16.4773H16.4925V14.9848H17.9925V16.4773ZM6.02252 17.9773H16.4925V16.4848H6.02252V17.9773ZM4.5 20.9553H17.9925V19.4628H4.5V20.9553ZM4.50751 16.4773H6.00751V14.9848H4.50751V16.4773ZM6.00751 7.49268H4.50751V6.00014H6.00751V7.49268ZM16.4925 7.49268H17.9925V6.00014H16.4925V7.49268ZM19.4925 14.9846H17.9925V7.49963H19.4925V14.9846ZM3 14.9846H4.5V7.49963H3V14.9846ZM13.515 11.9927H12.015V10.4927H10.515V8.99268H12.015V7.50018H13.515V8.99268H15.0075V10.4927H13.515V11.9927ZM6 6H7.5V4.50746H6V6ZM16.4925 6H14.9925V4.50746H16.4925V6Z",
    fill: "#FF3FF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicM);
export default __webpack_public_path__ + "static/media/epic-m.f383cbe46c1f1deff9fbfe0ddc093889.svg";
export { ForwardRef as ReactComponent };